<template>
  <AgentChatPopover v-if="agentEnabled && authUser && canChat && !onKiosk" />
</template>

<script setup>
import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'
import AgentChatPopover from './AgentChatPopover.vue'

const agentEnabled =
  import.meta.env.VITE_BIDBOOST_AGENT_ENABLED?.trim() === 'true'
const authUser = computed(() => usePage().props.authUser)
// The shared shop tablet is a single-purpose screen.
const onKiosk = computed(() => usePage().component?.startsWith('Shop/Kiosk'))
const canChat = computed(
  () => authUser.value?.authorizations?.agentOrganizationSkills?.chat ?? false
)
</script>
